function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  baseProfile: "tiny-ps",
  viewBox: "0 0 484 484"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M475.37 195.09v264.59c.05 6.6-2.74 12.9-7.66 17.3l-.7.7a23.35 23.35 0 0 1-15.22 5.57H31.46c-5.53 0-10.89-1.98-15.1-5.57-.28-.17-.52-.41-.69-.7a23.08 23.08 0 0 1-7.79-17.3V195.1a22.5 22.5 0 0 1 6.28-15.8c1.66-1.96 3.65-3.61 5.89-4.88 3.49-1.91 7.4-2.91 11.38-2.9h420.36c6.6.12 12.87 2.88 17.42 7.66a23.77 23.77 0 0 1 6.16 15.92z",
  style: {
    fill: "#81109c"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M469.23 179.15c-1.65 2.05-227.48 181.64-227.48 181.64L14.14 179.35l.1-.09v-.1L228.86 4.57a20.39 20.39 0 0 1 25.72 0z",
  style: {
    fill: "#a12dbd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.22 57.41v160.41L241.73 360.79 62.13 217.63V57.41z",
  style: {
    fill: "#eeefee"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M466.68 476.97c-.2.25-.43.48-.69.68L263.8 342.78l18.51-14.91zM218.54 343.68 16.35 478.63c-.29-.14-.54-.38-.68-.68l184.27-149.27z",
  style: {
    fill: "#a12dbd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.91 103.52h279.42v12.12H101.91zm0 40.76h279.42v12.12H101.91zm0 43.76h279.42v12.12H101.91zM307 229.8h74.41v12.12H307z",
  style: {
    fill: "#dbd8dd"
  }
}));
export default SvgEmailSvg;